import React, { useState } from 'react'

import { MdOutlineHelpOutline } from 'react-icons/md'
import { RiPencilLine, RiImage2Line } from 'react-icons/ri'
import { BiFullscreen } from 'react-icons/bi'

import { FunctionBar, CusttomAnnotationButton, ToolsMenuTooltip } from './styles'

interface ContentLessonProps {
  isText?: boolean
  handleModalDoubts?(): void
  setShowPDF?(showPDF: boolean): void
  showPDF?: boolean
  havePDF?: boolean
  openModalDuvida?: boolean
}

const AnnotationsFooterBar: React.FC<ContentLessonProps> = ({
  isText,
  handleModalDoubts,
  havePDF,
  showPDF,
  setShowPDF,
  openModalDuvida,
}) => {
  const [fullScreen, setFullScreen] = useState<boolean>(false)

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      if (document.documentElement.requestFullscreen) {
        setFullScreen(true)
        return document.documentElement.requestFullscreen()
      }
    } else {
      if (document.exitFullscreen) {
        setFullScreen(false)
        return document.exitFullscreen()
      }
    }
  }
  return (
    <FunctionBar isText={isText}>
      <CusttomAnnotationButton
        isText={isText}
        selected={!showPDF}
        onClick={() => setShowPDF(false)}
      >
        <div>
          <ToolsMenuTooltip title="Anotações">
            <RiPencilLine size={25} />
          </ToolsMenuTooltip>
        </div>
      </CusttomAnnotationButton>
      {havePDF && (
        <CusttomAnnotationButton
          isText={isText}
          onClick={() => setShowPDF(true)}
          selected={showPDF}
        >
          <div>
            <ToolsMenuTooltip title="Slide">
              <RiImage2Line size={25} />
            </ToolsMenuTooltip>
          </div>
        </CusttomAnnotationButton>
      )}
      <CusttomAnnotationButton isText={isText} data-openModal={openModalDuvida}>
        <div>
          <ToolsMenuTooltip title="Dúvidas">
            <MdOutlineHelpOutline onClick={handleModalDoubts} size={25} />
          </ToolsMenuTooltip>
        </div>
      </CusttomAnnotationButton>
      <CusttomAnnotationButton
        data-fullSreen={fullScreen}
        onClick={toggleFullScreen}
        isText={isText}
        selected={fullScreen}
      >
        <div>
          <ToolsMenuTooltip title="Tela cheia">
            <BiFullscreen size={25} />
          </ToolsMenuTooltip>
        </div>
      </CusttomAnnotationButton>
    </FunctionBar>
  )
}

export default AnnotationsFooterBar
